import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PaginationDetails } from "../../types";

interface PaginationProps {
  pagination: PaginationDetails;
  onPageChange: (page: number) => void;
  pageSize: number;
}

export const Pagination: React.FC<PaginationProps> = ({
  pagination,
  onPageChange,
  pageSize,
}) => {
  const { page, pages, total, hasNext, hasPrev } = pagination;

  const startItem = (page - 1) * pageSize + 1;
  const endItem = Math.min(page * pageSize, total);

  if (total === 0) return null;
  //  if (total === 0 || pages <= 1) return null;

  return (
    <div className="flex items-center justify-between px-6 py-3 max-sm:flex-col max-sm:items-start space-y-2">
      <div className="flex items-center space-x-2 text-sm text-dark-600">
        <span>
          Showing {startItem} to {endItem} of {total} results
        </span>
      </div>

      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(page - 1)}
          disabled={!hasPrev}
          className="inline-flex items-center space-x-1 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ChevronLeft className="h-4 w-4" />
          <span>Prev</span>
        </button>

        <div className="flex items-center space-x-1">
          <span className="text-sm text-dark-600">Page</span>
          {page} &nbsp;
          <span className="text-sm text-dark-600">of {pages}</span>
        </div>

        <button
          onClick={() => onPageChange(page + 1)}
          disabled={!hasNext}
          className="inline-flex items-center space-x-1 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <span>Next</span>
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
